/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types'
import React from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'
import './styles.css'
import { useNavigate } from 'react-router-dom'

export default function CustomDataPicker({
  date,
  setDate,
  setShowModal,
  onOpenCreateActivity,
}) {
  registerLocale('pt-BR', ptBR)

  const navigate = useNavigate()
  const goToAccessControl = () => {
    let slug = ''
    const parts = window.location.pathname.split('/').filter(Boolean)
    slug = parts[0] || ''

    if (slug) {
      navigate(`/${slug}/acompanhamento/controle-de-acesso`)
    } else {
      navigate('../controle-de-acesso')
    }
  }

  const formatWeekDay = (day) => {
    return day.charAt(0)
  }

  const handleDateChange = (date) => {
    setDate(date)
  }
  const commonButtonStyle = {
    backgroundColor: 'white',
    border: 'none',
    padding: '15px 20px',
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center',
    width: '310px',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.2)'
  }

  const CustomHeaderPicker = ({
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10
    }}
    >

      <div
        style={{
          display: 'flex',
          gap: 10,
        }}
      >
        <span
          style={{
            fontWeight: 600,
            fontSize: 16,
            marginLeft: 10,
            marginTop: 15,
          }}
        >
          {date.toLocaleDateString('pt-BR', { month: 'long' })}
          {' de '}
          {date.getFullYear()}
        </span>

      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: 10,
          marginTop: 5,
        }}
      >
        <button
          className="btn-data-picker"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          {'<'}
        </button>
        <button
          className="btn-data-picker"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          {'>'}
        </button>
      </div>
    </div>
  )

  return (
    <div
      style={
              {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '100%',
                padding: '0 30px',
                marginTop: 40,
                gap: 10,
              }
            }
    >
      <span style={{ ...commonButtonStyle, marginBottom: 10 }} onClick={() => setShowModal(true)}>
        Agendar Atividade
      </span>

      <span style={{ ...commonButtonStyle, marginBottom: 10 }} onClick={onOpenCreateActivity}>
        Criar atividade
      </span>

      <span style={{ ...commonButtonStyle, marginBottom: 50 }} onClick={goToAccessControl}>
        Controle de Acessos
      </span>

      <DatePicker
        selected={date}
        onChange={handleDateChange}
        locale="pt-BR"
        inline
        renderCustomHeader={CustomHeaderPicker}
        formatWeekDay={formatWeekDay}
        calendarClassName="custom-datepicker"
      />
    </div>
  )
}

CustomDataPicker.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
}
